import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import MainLayout from "../layout/MainLayout/MainLayout";
import Login from "../pages/AuthPage/Login/Login";
import Verification from "../pages/AuthPage/Verification/Verification";
import ForgotPassword from "../pages/AuthPage/ForgotPassword/ForgotPassword";
import NewPassword from "../pages/AuthPage/NewPassword/NewPassword";
import Messages from "../pages/Messages/Messages";
import CreateAccount from "../pages/AuthPage/CreateAccount/CreateAccount";
import Subscription from "../pages/AuthPage/Subscription/Subscription.js";
import AccountSetup from "../pages/AuthPage/AccountSetup/AccountSetup.js";
import TermsConditions from "../pages/AuthPage/TermsConditions/TermsConditions.js";
import PrivacyPolicy from "../pages/AuthPage/PrivacyPolicy/PrivacyPolicy.js";
import Billing from "../pages/Billing/Billing.js";
import SubscriptionPlan from "../pages/SubscriptionPlan/SubscriptionPlan.js";
import ArtworkList from "../pages/Artwork/ArtworkList.js";
import AllSetPage from "../pages/Artwork/AllSetPage.js";
import MyProfile from "../pages/MyProfile/MyProfile.js";
import InvoicePage from "../pages/InvoicePage/InvoicePage.js";
import { ProfileProvider } from "../context/ProfileContext.js";

const publicRoutes = [
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },
  { path: "/forgot_password", element: <ForgotPassword /> },
  { path: "/verification/:type", element: <Verification /> },
  { path: "/new_password", element: <NewPassword /> },
  { path: "/create_account", element: <CreateAccount /> },
  { path: "/subscription", element: <Subscription /> },
  { path: "/account_setup", element: <AccountSetup /> },
  { path: "/terms-conditions", element: <TermsConditions /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
];

const privateRoutes = [
  { path: "/subscription_plan", element: <SubscriptionPlan /> },
  { path: "/all_set_page", element: <AllSetPage /> },
  { path: "/artwork_list", element: <ArtworkList /> },
  { path: "/messages", element: <Messages /> },
  { path: "/billing", element: <Billing /> },
  { path: "/invoice/:id", element: <InvoicePage /> },
  { path: "/profile", element: <MyProfile /> },
];

const RouterContainer = () => {
  const isAuthenticated = !!localStorage.getItem("artistToken");

  return (
    <BrowserRouter>
      <ProfileProvider>
        <Routes>
          {publicRoutes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={<PublicRoute>{element}</PublicRoute>}
            />
          ))}

          {privateRoutes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={
                <PrivateRoute>
                  <MainLayout>{element}</MainLayout>
                </PrivateRoute>
              }
            />
          ))}

          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate to="/all_set_page" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ProfileProvider>
    </BrowserRouter>
  );
};

export default RouterContainer;